<template>
    <div>
        <v-card raised>
            <v-card-title>
                Ticket Issued Lookup
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingTicketIssued" :headers="headers" :items="ticketissued" :search="search" class="elevation-1">
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingTicketIssued: false,
                ticketissued: [],
                headers: [
                    { text: 'Ticket Number', align: 'left', sortable: true, value: 'ticket_nbr',},
                    { text: 'Name', align: 'left', sortable: true, value: 'violators_name',},
                    { text: 'Contact', value: 'violators_phone' },
                    { text: 'Address Street 1', value: 'addr_street_1'},
                    { text: 'Address Street 2', value: 'addr_street_2'},
                    { text: 'Address City', value: 'addr_city'},
                    { text: 'Address State', value: 'addr_state_name'},
                    { text: 'Address Zip', value: 'addr_zip'},
                    { text: 'Violation Type', value: 'violationtype.violation_label'},
                    { text: 'Ticket Price', value: 'ticket_price'},
                    { text: 'Payment Status', value: 'transaction.status'},
                    { text: 'Payment Date', value: 'transaction.paydate'},
                    { text: 'Transaction ID', value: 'transaction.transactionid'},

                ],
            }
        },
        created() {
            this.fetchTicketIssued();
        },
        methods: {
            fetchTicketIssued: function () {
                this.loadingTicketIssued= true;
                axios.get(this.appURL + '/api/ticketissued')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            this.ticketissued = response.data;
                        }
                        this.loadingTicketIssued = false;
                    })
                    .catch(error => {
                        this.loadingTicketIssued = false;
                });
            }
        }
    }
</script>
